import { render, staticRenderFns } from "./SchoolWorksDetail.vue?vue&type=template&id=6de3c742"
import script from "./SchoolWorksDetail.vue?vue&type=script&lang=js"
export * from "./SchoolWorksDetail.vue?vue&type=script&lang=js"
import style0 from "./SchoolWorksDetail.vue?vue&type=style&index=0&id=6de3c742&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports